import { useState } from 'react'
import axios from 'axios'
import Link from 'next/link'

import {
	Row,
	Col,
	Card,
	Form,
	InputGroup,
	Button,
	Modal,
	Image
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

const ForgotPassword: React.FC = () => {
	const [email, setEmail] = useState('')
	const [show, setShow] = useState(false)
	const { t } = useTranslation()

	const handleSubmit = (event): void => {
		event.preventDefault()
		event.stopPropagation()

		const obj = { email }
		axios.post(process.env.NEXT_PUBLIC_FORGOT_PASSWORD as string, obj).catch(() => null)
		setShow(true)
	}

	return (
		<>
			<Modal
				show={show}
				onHide={() => setShow(false)}
			>
				<Modal.Header closeButton />
				<Modal.Body>
					<p className='text-center'>
						{t('forgot_password.check_email')}
					</p>
				</Modal.Body>
			</Modal>
			<Row className='justify-content-center'>
				<Col md={6}>
					<Card>
						<Card.Body style={{ padding: '50px', textAlign: 'center' }}>
							<br />
							<Image src='/img/forgot-password.png' alt=''/>
							<br /><br /><br />
							<h2>{t('login.forgot_password')}</h2>
							<br />
							<p style={{ color: '#6c757d' }}>
								{t('forgot_password.enter_email_to_reset_password')}
							</p>
							<br />
							<Form onSubmit={handleSubmit}>
								<InputGroup>
									<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
										<FontAwesomeIcon icon={faEnvelope} />
									</InputGroup.Text>
									<Form.Control
										size='lg'
										placeholder={t('login.email_address')}
										style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderLeft: '0px', borderColor: '#EBEBEB' }}
										type='email'
										value={email}
										onChange={event => setEmail(event.target.value)}
										required
										pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
										title='Please enter a valid email address.'
									/>
								</InputGroup>

								<Row>
									<Col style={{ textAlign: 'right', marginTop: '5px' }}>
										<Link href='/login' passHref>
											<Button variant='link' className='text-decoration-none'>{t('login.login')}</Button>
										</Link>
									</Col>
								</Row>

								<br />
								<Button variant='primary' className='text-white' type='submit' size='lg' style={{ width: '100%', borderRadius: '10px' }}>
									{t('forgot_password.reset_password')}
								</Button>
								<br /><br />
							</Form>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	)
}

export async function getStaticProps ({ locale }) {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common']))
			// Will be passed to the page component as props
		}
	}
}

export default ForgotPassword
